function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 24,
  height: 16,
  fill: "url(#pattern02)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("pattern", {
  id: "pattern02",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, React.createElement("use", {
  xlinkHref: "#image0_3643_7721",
  transform: "translate(0 -0.001) scale(0.004 0.006)"
})), React.createElement("image", {
  id: "image0_3643_7721",
  width: 250,
  height: 167,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAACnCAYAAAA4/EEUAAAE0ElEQVR4Ae3VMZUVYRQE4VGCARJSNOANGRvgYWWsAJQMBwc37vreOS+b5HZ1/f28fhKQwHwCz/yFDpSABF6iK4EEAgkQPQDZiRIgug5IIJAA0QOQnSgBouuABAIJED0A2YkSILoOSCCQANEDkJ0oAaLrgAQCCRA9ANmJEiC6DkggkADRA5CdKAGi64AEAgkQPQDZiRIgug5IIJAA0QOQnSgBouuABAIJED0A2YkSILoOSCCQANEDkJ0oAaLrgAQCCRA9ANmJEiC6DkggkADRA5CdKAGi64AEAgkQPQDZiRIgug5IIJAA0QOQnSgBouuABAIJED0A2YkSILoOSCCQANEDkJ0oAaLrgAQCCRA9ANmJEiC6DkggkADRA5CdKAGi64AEAgkQPQDZiRIgug5IIJAA0QOQnSgBouuABAIJED0A2YkSILoOSCCQANEDkJ0oAaLrgAQCCRA9ANmJEiC6DkggkADRA5CdKAGi64AEAgkQPQDZiRIgug5IIJAA0QOQnSgBouuABAIJPH8+/77+MtCB7Q48z8+P118GOjDeAYDHAXvIDdn/DhCd6DoQ6ADIAchW3aoTneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDoAMgByBbdohOd6DoQ6ADIAcgW3aITneg6EOgAyAHIFt2iE53oOhDowO8fv15/GejAdgeer+/fXn8Z6MB2B4juofPQBzpA9ABka7291he+RCe6RQ90gOgByJcX3zfbq090olv0QAeIHoBsrbfX+sKX6ES36IEOED0A+fLi+2Z79YlOdIse6ADRA5Ct9fZaX/gSnegWPdABogcgX15832yvPtGJbtEDHSB6ALK13l7rC1+iE92iBzpA9ADky4vvm+3VJzrRLXqgA0QPQLbW22t94Ut0olv0QAeIHoB8efF9s736RCe6RQ90gOgByNZ6e60vfIlOdIse6ADRA5AvL75vtlef6ES36IEOED0A2Vpvr/WFL9GJbtEDHSB6APLlxffN9uoTnegWPdABogcgW+vttb7wJTrRLXqgA0QPQL68+L7ZXn2iE92iBzpA9ABka7291he+RCe6RQ90gOgByJcX3zfbq090olv0QAeIHoBsrbfX+sKX6ES36IEOED0A+fLi+2Z79YlOdIse6ADRA5Ct9fZaX/gSnegWPdABogcgX15832yvPtGJbtEDHSB6ALK13l7rC1+iE92iBzpA9ADky4vvm+3VJzrRLXqgA0QPQLbW22t94Ut0olv0QAeIHoB8efF9s736RCe6RQ90gOgByNZ6e60vfP8BV3sVIOcL8m0AAAAASUVORK5CYII="
}));

var SvgRusFlag = function SvgRusFlag(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRusFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rus_flag.a60190f7.svg";
export { ForwardRef as ReactComponent };